import React from 'react';

export function PhoneEditIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4435 3.19992L4.28605 9.71742C4.05355 9.96492 3.82855 10.4524 3.78355 10.7899L3.50605 13.2199C3.40855 14.0974 4.03855 14.6974 4.90855 14.5474L7.32355 14.1349C7.66105 14.0749 8.13355 13.8274 8.36605 13.5724L14.5235 7.05492C15.5885 5.92992 16.0685 4.64742 14.411 3.07992C12.761 1.52742 11.5085 2.07492 10.4435 3.19992Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.41797 4.2876C9.74047 6.3576 11.4205 7.9401 13.5055 8.1501"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 17H16.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
